import "./CreateAccount.less";

import React, { Component } from "react";
import { Link } from "react-router-dom";
import { translate } from "react-i18next";
import queryString from "query-string";
import StepWizard from "react-step-wizard";

import { InstitutionSelect } from "./InstitutionSelect/InstitutionSelect";
import { RoleSelect } from "./RoleSelect/RoleSelect";
import AccountForm from "./AccountForm/AccountForm";
import logo from "../../assets/images/plantyn_logo.svg";
import { CreateAccountContext } from "../../contexts/contexts";
import SuperdogInfo from "../WizardSteps/SuperdogInfo/SuperdogInfo";

class CreateAccount extends Component {
	/**
	 * We must set some props to undefined when we go back to a previous state
	 * resultProps is meant to be an array with property keys,
	 * telling us which props must be set to undefined
	 */

	state = {
		role: undefined,
		school: undefined,
		institution: undefined,
		setRole: value => this.setState({ role: value }),
		setSchool: value => this.setState({ school: value }),
		setInstitution: value => this.setState({ institution: value })
	};

	render() {
		const t = this.props.t;

		const currentQuery = queryString.parse(window.location.search);
		const returnUrl = currentQuery.returnUrl;
		const query = queryString.stringify({ returnUrl });

		return (
			<CreateAccountContext.Provider value={this.state}>
				<h1>{t("createAnAccount")}</h1>
				<StepWizard transitions={{}}>
					<RoleSelect />
					<InstitutionSelect />
					<AccountForm />
					<SuperdogInfo description={t("emailVerification")} />
				</StepWizard>
				<div className="register_cta">
					<p>
						{t("alreadyHaveAccount")}
						<Link to={"/login?" + query}>{t("logIn")}</Link>
					</p>
				</div>
				<img className="plantyn_logo" src={logo} alt="" />
			</CreateAccountContext.Provider>
		);
	}

	// Not used?
	
	/*backClickHandler() {
		const currentStateData = this.getCurrentStateDicitonaryData();
		const prevState = this.getPreviousState();
		const undefinedStateValues = currentStateData.resultProps.reduce((prev, curr) => Object.assign(prev, { [curr]: undefined }), {});
		const newStateToSet = { ...undefinedStateValues, registrationState: prevState };

		this.setState(newStateToSet);
	}

	nextClickHandler(result) {
		const currentQuery = queryString.parse(this.props.location.search);
		const returnUrl = currentQuery.returnUrl;

		// if student is selected as role
		if (result.role && result.role === "student") {
			const query = queryString.stringify({ returnUrl: returnUrl });
			window.location = `/aanmelden/leerling?${query}`;
			return;
		}

		// if teacher is selected as role and we are at the end of the form
		if (result.provider) {
			const query = queryString.stringify({
				provider: result.provider,
				hoofdstructuur: this.state.institution.id,
				onderwijsRegio: this.state.school.id,
				returnUrl: returnUrl
			});
			window.location = `/aanmelden/leerkracht?${query}`;
			return;
		}

		const newStateToSet = { ...result, registrationState: this.getNextState() };

		this.setState(newStateToSet);
	}*/
}

const translateCreateAccount = translate("registration")(CreateAccount);
export { translateCreateAccount as CreateAccount, CreateAccountContext };



// WEBPACK FOOTER //
// ./src/components/CreateAccount/CreateAccount.js